const topics = [
  { tag: '#古装剧天花板', heat: '128万讨论', color: 'accent' },
  { tag: '#长安风云录大结局', heat: '96万讨论', color: 'primary' },
  { tag: '#韩剧推荐清单', heat: '85万讨论', color: 'accent' },
  { tag: '#悬疑剧反转王', heat: '72万讨论', color: 'primary' },
  { tag: '#周末追剧指南', heat: '68万讨论', color: 'accent' },
  { tag: '#国产剧崛起', heat: '61万讨论', color: 'primary' },
  { tag: '#高甜恋爱剧', heat: '55万讨论', color: 'accent' },
  { tag: '#美剧入坑推荐', heat: '49万讨论', color: 'primary' },
  { tag: '#免会员追剧', heat: '43万讨论', color: 'accent' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            剧迷们正在热议的追剧话题，加入讨论发现更多好剧
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => {
            const isAccent = topic.color === 'accent';
            return (
              <div
                key={topic.tag}
                className={`group flex items-center gap-3 px-5 py-3 rounded-full border cursor-pointer transition-all duration-300 ${
                  isAccent
                    ? 'bg-accent-50 border-accent-200 hover:bg-accent-100 hover:border-accent-300'
                    : 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                }`}
              >
                <span className={`text-sm font-semibold font-heading whitespace-nowrap ${
                  isAccent ? 'text-accent-800' : 'text-primary-800'
                }`}>
                  {topic.tag}
                </span>
                <span className={`text-xs whitespace-nowrap ${
                  isAccent ? 'text-accent-500' : 'text-primary-500'
                }`}>
                  {topic.heat}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}